import React from 'react';
import {TeamImage, Stat, Container, Team, RankStat} from 'app/components/standings/StandingsStyles';
import {Typography} from '@fupa/fupa-uikit';

const LeagueSpectatorsHeader = () => {
  return (
    <Container>
      <RankStat align='left' minWidth={24} setMaxWidth={true}>
        <Typography variant='caption1'>Pl.</Typography>
      </RankStat>
      <TeamImage />
      <Team>
        <Typography variant='caption1'>Team</Typography>
      </Team>
      <Stat align='center' minWidth={32}>
        <Typography variant='caption1'>Sp.</Typography>
      </Stat>
      <Stat align='center' minWidth={48}>
        <Typography variant='caption1'>Zus.</Typography>
      </Stat>
      <Stat align='center' minWidth={36}>
        <Typography variant='caption1'>∅</Typography>
      </Stat>
    </Container>
  );
};

export default LeagueSpectatorsHeader;
